module.exports = __webpack_public_path__ + "img/MC-Logo-White.16f440b.png";